import { initGraphQLTada } from 'gql.tada';
export const graphql = initGraphQLTada();
//# sourceMappingURL=graphql.js.map